import { render, staticRenderFns } from "./PromotionAccessoryHistoryTable.vue?vue&type=template&id=55b5077c"
import script from "./PromotionAccessoryHistoryTable.vue?vue&type=script&lang=js"
export * from "./PromotionAccessoryHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports